<template>
    <div>
        <Collapse v-model="value" simple style="border:0">
            <Panel name="1" hide-arrow style="margin: 20px 0;border:0" >
                <FormTitle :titleText="$t('Contract_List')"/><!-- 合同列表 -->
                <div slot="content" style="margin-top: 40px;">
                    <Table border :loading="loading" :columns="columns" :data="data"> </Table>
                    <div style="margin:20px 0;">
                        <Page style="float: right" :total="total" @on-change="pageChange"/>
                    </div>
                </div>
            </Panel>
            <div  v-if="id==''">
                <span style="color: red;">{{$t('EmpFilesComment')}}</span>
            </div> 
        </Collapse>
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            formItem:{},
            list:[],
            value:[1],
            date: new DateUtil(),
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[],
            id:'',
            serialnumber:''
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('Start_Date'),/* 开始日期 */
                    key: "begindate",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    render: (h, params) => {
                        return h(
                            "span",
                            this.date.dateVal(params.row.begindate, "YYYY-MM-DD")
                        );
                    },
                },{
                    title: this.$t('End_Date'),/* 结束日期 */
                    key: "enddate",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    render: (h, params) => {
                        return h(
                            "span",
                            this.date.dateVal(params.row.enddate, "YYYY-MM-DD")
                        );
                    },
                },{
                    title: this.$t('Contract_Type'),/* 签订类型 */
                    key: "contracttype",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                }
            ]
        }
    },
    methods:{
        getData(val){
            this.loading=true
            val?this.serialnumber=val:this.serialnumber=JSON.parse(sessionStorage.getItem("userInfo")).serialnumber
            axios.post("/contractList/getContractList", {...this.pageInfo,serialnumber:this.serialnumber}).then((res) => {
                this.loading=false
                if (res) {
                   this.data=res.data
                   this.total=parseInt(res.pageInfo.total)
                }
            })
        },
        pageChange(val){
            this.pageInfo.pageNo = val
            this.getData(this.serialnumber)
        },
    }
}
</script>

<style lang="less" scoped>
.btnfooter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/ContractList.vue